import {
  MODERN_FRAME_DEFAULT_PERMISSION,
  MODERN_FRAME_DEFAULT_NAMESPACE,
  MODERN_FRAME_NAMESPACES,
  MODERN_FRAME_PERMISSION_REGISTRATIONS,
  type ModernFrameNamespaceId,
  type RegisteredModernFrameNamespace,
  type RegisteredModernFramePermission,
} from './modern-frame-namespaces.registry.js';
import { toCanonicalModernUrl } from './modern-frame-url.js';

export function getModernFrameDefaultRoute(): string {
  return MODERN_FRAME_DEFAULT_PERMISSION.defaultRoute;
}

export function getModernFrameDefaultPagePath(): string {
  return MODERN_FRAME_DEFAULT_PERMISSION.pagePath;
}

export function isModernFrameNamespaceSegment(segment: string): segment is ModernFrameNamespaceId {
  return MODERN_FRAME_NAMESPACES.some((entry) => entry.namespace === segment);
}

export function resolveModernFrameNamespace(value: string): RegisteredModernFrameNamespace | null {
  const permission = resolveModernFramePermission(value);
  if (permission === null) return null;
  return MODERN_FRAME_NAMESPACES.find((entry) => entry.namespace === permission.namespace) ?? null;
}

export function resolveModernFramePermission(value: string): RegisteredModernFramePermission | null {
  const canonicalUrl = toCanonicalModernUrl(value);
  if (canonicalUrl === null) {
    return null;
  }

  const pathname = canonicalUrl.split(/[?#]/, 1)[0] ?? '';
  return MODERN_FRAME_PERMISSION_REGISTRATIONS.find((entry) =>
    entry.routePatterns.some((pattern) => matchesRoutePattern(pathname, pattern))
  ) ?? null;
}

export function resolveModernFramePagePath(value: string): string | null {
  return resolveModernFramePermission(value)?.pagePath ?? null;
}

export function isAllowedModernFramePathname(pathname: string): boolean {
  return resolveModernFramePermission(pathname) !== null;
}

export function isModernFrameRouteCandidate(value: string): boolean {
  const canonicalUrl = toCanonicalModernUrl(value);
  if (canonicalUrl === null) return false;
  const pathname = canonicalUrl.split(/[?#]/, 1)[0] ?? '';
  const namespace = pathname.split('/').filter(Boolean)[0];
  return namespace !== undefined && isModernFrameNamespaceSegment(namespace);
}

function matchesRoutePattern(pathname: string, pattern: string): boolean {
  if (pattern.endsWith('/**')) {
    const base = pattern.slice(0, -3);
    return pathname === base || pathname.startsWith(base + '/');
  }

  const patternSegments = pattern.split('/').filter(Boolean);
  const pathSegments = pathname.split('/').filter(Boolean);
  if (patternSegments.length !== pathSegments.length) return false;

  return patternSegments.every((segment, index) =>
    segment.startsWith(':') ? pathSegments[index]!.length > 0 : segment === pathSegments[index]
  );
}
